// src/profile/AvatarUploadInput.tsx
import * as React from "react";
import { useInput } from "react-admin";
import { Box, Button, Typography } from "@mui/material";
import PlayerIdentityRow from "./PlayerIdentityRow";

export function AvatarUploadInput(props: { source: string, points: number }) {
  const { field } = useInput({ source: props.source });
  const points = props.points;
  const [previewUrl, setPreviewUrl] = React.useState<string | null>(null);

  const makeAbsolute = (url?: string | null) => {
    if (!url) return null;
    if (url.startsWith("http")) return url;
    return `${process.env.REACT_APP_CDN_URL ?? ""}/static/avatars/${url}`;
  };

  // bestehendes Avatar aus Backend anzeigen
  React.useEffect(() => {
    if (field.value instanceof File) return;
    if (typeof field.value === "string") {
      setPreviewUrl(makeAbsolute(field.value));
    } else {
      setPreviewUrl(null);
    }
  }, [field.value]);

  // ObjectURL sauber freigeben
  React.useEffect(() => {
    return () => {
      if (previewUrl?.startsWith("blob:")) {
        URL.revokeObjectURL(previewUrl);
      }
    };
  }, [previewUrl]);

  const onPick = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0] ?? null;

    // ✅ WICHTIG: File direkt setzen (react-admin!)
    field.onChange(file);

    if (file) {
      const url = URL.createObjectURL(file);
      setPreviewUrl(url);
    } else {
      setPreviewUrl(null);
    }
  };

  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 2, mb: 2 }}>
      {/* Avatar Preview */}
      <PlayerIdentityRow
        firstName={undefined}
        lastName={undefined}
        email={undefined}
        points={points}
        avatarUrl={previewUrl}
        showPoints={false}
        size="lg"
        showName={false}
      />

      {/* Controls */}
      <Box>
        <Typography variant="subtitle2" sx={{ mb: 0.5 }}>
          Profilbild
        </Typography>

        <Button component="label" variant="outlined" size="small">
          Bild auswählen
          <input hidden accept="image/*" type="file" onChange={onPick} />
        </Button>

        {field.value instanceof File && (
          <Typography
            variant="caption"
            sx={{ display: "block", mt: 0.5, opacity: 0.8 }}
          >
            {field.value.name}
          </Typography>
        )}
      </Box>
    </Box>
  );
}
